/* eslint-disable no-bitwise */
const BASE58_ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';

function base58Decode(str: string): Uint8Array {
  const bytes = [ 0 ];

  for (let i = 0; i < str.length; i++) {
    const value = BASE58_ALPHABET.indexOf(str[i]);
    if (value === -1) throw new Error('Invalid Base58 character');

    let carry = value;

    for (let j = 0; j < bytes.length; j++) {
      carry += bytes[j] * 58;
      bytes[j] = carry & 0xff;
      carry >>= 8;
    }

    while (carry > 0) {
      bytes.push(carry & 0xff);
      carry >>= 8;
    }
  }

  for (let i = 0; i < str.length && str[i] === '1'; i++) {
    bytes.push(0);
  }

  return Uint8Array.from(bytes.reverse());
}

export function isValidSolanaAddress(address: string): boolean {
  try {
    if (typeof address !== 'string') return false;

    // reject Ethereum-style addresses
    if (address.startsWith('0x')) return false;

    // basic length guard (fast fail)
    if (address.length < 32 || address.length > 44) return false;

    const decoded = base58Decode(address);

    return decoded.length === 32;
  } catch {
    return false;
  }
}

export function renderWalletName(wallet?: string): string {
  if (!wallet) return '';
  if (wallet.length <= 12) return wallet;
  return `${wallet.slice(0, 6)}...${wallet.slice(-6)}`;
}
